//DEPENDENCIES
import React from 'react';

// GLOBAL HELPERS
import { getListData } from 'helpers/getListData';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';
import { INTERFACE, SETTINGS, SPOT_INSTRUCTIONS } from 'pathnames.js';

// GLOBAL FUNCITONS
import { makePath } from 'functions';

// PARTS
import Main from 'parts/main/Main';
import Table, { Filters } from 'parts/table/Table';
import Title from 'parts/title/Title';

// LOCAL VARIABLES
import { ACTIONS, COLUMNS } from 'columns';

// MAIN COMPONENT
const CommonSpotInstructions = () => {
  // RETURN
  return (
    <Main>
      <Title
        documentTitle="Common Spot Instructions"
        title="Common Spot Instructions"
        tools={<Title.AddRecord label="Common Spot Instruction" />}
      />
      <Filters>
        <Filters.Button.Active />
        <Filters.Search name="spotInstructionTitle" placeholder="Search by title" />
        <Filters.Reset />
      </Filters>
      <Table mobilePreviewKeys={['common_spot_instruction_title', 'date_updated']} />
    </Main>
  );
};

// EXPORT
export default getListData(CommonSpotInstructions, {
  key: 'automatedSpotInstructions',
  path: makePath(INTERFACE.settings, SETTINGS.spotInstructions, SPOT_INSTRUCTIONS.common),
  fetchArgs: {
    endpoint: makePath(ENDPOINTS.admin.spotInstructions.common.list)
  },
  columns: [
    {
      ...COLUMNS.updatedOn,
      component: null
    },
    {
      key: 'common_spot_instruction_title',
      label: 'Title',
      width: 200
    },
    {
      component: Table.Boolean,
      key: 'upload_document_required',
      label: 'Upload Doc Required',
      className: 'text-center',
      width: 120
    },
    COLUMNS.active,
    {
      key: 'updated_by_user',
      label: 'User',
      width: 80
    }
  ],
  actions: [ACTIONS.edit('common_spot_instruction_id')]
});
